import { Routes } from '@angular/router';
import { DoctorInfoComponent } from './doctor-info/doctor-info.component';

export const DoctorsRoutes: Routes = [
	{ path: '', component: DoctorInfoComponent }
];
